{
    "(None)": "",
    "(save {highestYearlyDiscount}%)": "",
    "{amount} days free": "{amount} دن مفت پڑھیں",
    "{amount} off": "{amount} کم",
    "{amount} off for first {number} months.": "{number} مہینوں کے لئے {amount} کمی",
    "{amount} off for first {period}.": "{period} کے لئے {amount} کمی",
    "{amount} off forever.": "{amount} ہمیشہ کے لئے کم",
    "{buyerName} has gifted you a <strong>{duration}-month</strong> {tierName} membership to {siteTitle}_one": "",
    "{buyerName} has gifted you a <strong>{duration}-month</strong> {tierName} membership to {siteTitle}_other": "",
    "{buyerName} has gifted you a <strong>{duration}-year</strong> {tierName} membership to {siteTitle}": "",
    "{discount}% discount": "{discount}٪ چھوٹ",
    "{duration} membership": "",
    "{field}: {message}": "",
    "{memberEmail} will no longer receive {newsletterName} newsletter.": "{memberEmail} کو مزید {newsletterName} نیوزلیٹر نہیں ملے گا۔",
    "{memberEmail} will no longer receive emails when someone replies to your comments.": "{memberEmail} کو مزید ای میل نہیں ملے گا جب کوئی آپکے تبادلوں کا جواب دیتا ہے۔",
    "{memberEmail} will no longer receive this newsletter.": "{memberEmail} کو مزید یہ نیوزلیٹر نہیں ملے گا۔",
    "{memberEmail} will no longer receive updates & announcements.": "",
    "{months} month": "",
    "{months} months": "",
    "{months} months free": "",
    "{tierName} membership": "",
    "{trialDays} days free": "{trialDays} دن مفت پڑھیں",
    "{years} years": "",
    "+1 (123) 456-7890": "",
    "1 month": "",
    "1 month free": "",
    "1 year": "",
    "A gift, just for you": "",
    "Access your RSS feeds": "",
    "Account": "اکاؤنٹ",
    "Account details updated successfully": "",
    "Account settings": "اکاؤنٹ کی ترتیبات",
    "Add a personal note": "",
    "Add a short note to go with your gift": "",
    "Address line 1": "",
    "Address line 2": "",
    "After a free trial ends, you will be charged the regular price for the tier you've chosen. You can always cancel before then.": "جب مفت ڈھانچا ختم ہو جائے گا، آپکو اس ڈھانچے کے لئے عام قیمت چارج ہوگی جس پر آپ نے فیصلہ کیا ہوا ہے۔ آپ ہمیشہ اس سے پہلے منسلک کر سکتے ہیں۔",
    "Already a member?": "پہلے ہی ممبر ہیں؟",
    "An error occurred": "",
    "An unexpected error occured. Please try again or <a>contact support</a> if the error persists.": "ایک غیر متوقعہ خطا واقع ہوگئی ہے۔ براہ کرم دوبارہ کوشش کریں یا اگر خطا جاری رہے تو <a>سپورٹ سے رابطہ کریں</a>۔",
    "Back": "پیچھے",
    "Back to Log in": "لاگ ان پر واپسی",
    "Before you go": "",
    "Billing info & receipts": "",
    "Black Friday": "کالا جمعہ",
    "Bluesky": "",
    "Buy": "",
    "Buying for someone else?": "",
    "Cancel anytime.": "کسی بھی وقت منسلک کریں۔",
    "Cancel subscription": "سبسکرپشن منسلک کریں",
    "Canceled": "",
    "Cancellation reason": "منسلک کرنے کا وجہ",
    "Change": "تبدیل کریں",
    "Change plan": "",
    "Check spam & promotions folders": "اسپیم اور پروموشن فولڈر چیک کریں",
    "Check with your mail provider": "آپکے میل فراہم کنندہ کے ساتھ چیک کریں",
    "Check your inbox to verify email update": "",
    "Choose": "منتخب کریں",
    "Choose a date from today onwards": "",
    "Choose a date within the next year": "",
    "Choose a delivery date": "",
    "Choose a different plan": "مختلف منصوبہ منتخب کریں",
    "Choose a plan": "",
    "Choose a tier": "",
    "Choose your newsletters": "اپنے نیوزلیٹر کو منتخب کریں",
    "City": "",
    "Click here to retry": "دوبارہ کوشش کرنے کے لئے یہاں کلک کریں",
    "Click the confirmation link in your inbox to finish redeeming your membership. If it doesn't arrive within 3 minutes, check your spam folder.": "",
    "Close": "بند کریں",
    "Code": "",
    "Comment preferences updated.": "",
    "Comments": "تبادلے",
    "Complimentary": "تعریف",
    "Confirm": "تصدیق",
    "Confirm cancellation": "منسلک کرنے کی تصدیق",
    "Confirm subscription": "سبسکرپشن کی تصدیق",
    "Contact support": "سپورٹ سے رابطہ کریں",
    "Continue": "جاری رہے",
    "Continue subscription": "سبسکرپشن جاری رکھیں",
    "Continue to delivery details": "",
    "Continue to payment": "",
    "Continue with a paid subscription anytime. Your remaining gift period will be added as a free trial.": "",
    "Copied": "",
    "Copy": "",
    "Copy link": "",
    "Could not create Stripe billing portal session": "",
    "Could not create Stripe checkout session": "",
    "Could not sign in. Login link expired.": "سائن ان نہیں ہو سکا۔ لاگ ان لنک کا وقت ختم ہو گیا ہے۔",
    "Could not update email! Invalid link.": "ای میل اپ ڈیٹ نہیں ہو سکا! غیر معتبر لنک۔",
    "Country": "",
    "Create a new contact": "نیا رابطہ بنائیں",
    "Current plan": "موجودہ منصوبہ",
    "Delete account": "اکاؤنٹ حذف کریں",
    "Delivery date": "",
    "Delivery method": "",
    "Didn't mean to do this? Manage your preferences <button>here</button>.": "یہ کرنا میرا مطلب نہیں تھا؟ اپنی ترجیحات کا منظم کریں <button>یہاں</button>۔",
    "Don't have an account?": "اکاؤنٹ نہیں ہے؟",
    "Edit": "ترتیب",
    "Email": "ای میل",
    "Email confirmation link expired.": "",
    "Email it to them": "",
    "Email newsletter": "ای میل نیوزلیٹر",
    "Email newsletter settings updated": "",
    "Email preferences": "ای میل کی ترجیحات",
    "Email preferences updated.": "",
    "Emails": "ای میلز",
    "Emails disabled": "ای میلز غیر فعال ہیں",
    "Ends {offerEndDate}": "ختم ہوتا ہے {offerEndDate}",
    "Enjoy {amountOff} off forever.": "",
    "Enjoy {months} free months on us.": "",
    "Enjoy {months} free months on us. You won't be charged until {newBillingDate}.": "",
    "Enjoy a free month on us.": "",
    "Enjoy a free month on us. You won't be charged until {newBillingDate}.": "",
    "Enter code above": "",
    "Enter the recipient's email address": "",
    "Enter your email address": "",
    "Enter your name": "",
    "Error": "خطا",
    "Expires {expiryDate}": "ختم ہوتا ہے {expiryDate}",
    "Facebook": "",
    "Failed to cancel subscription, please try again": "",
    "Failed to log in, please try again": "",
    "Failed to log out, please try again": "",
    "Failed to open billing portal, please try again": "",
    "Failed to process checkout, please try again": "",
    "Failed to send magic link email": "",
    "Failed to send verification email": "",
    "Failed to sign up, please try again": "",
    "Failed to update account data": "",
    "Failed to update account details": "",
    "Failed to update billing information, please try again": "",
    "Failed to update newsletter settings": "",
    "Failed to update subscription, please try again": "",
    "Failed to verify code, please try again": "",
    "For a friend or colleague": "",
    "Forever": "ہمیشہ کے لئے",
    "Free Trial – Ends {trialEnd}": "مفت ڈھانچا – ختم ہوتا ہے {trialEnd}",
    "From": "",
    "Get help": "مدد حاصل کریں",
    "Get in touch for help": "مدد کے لئے رابطہ کریں",
    "Get notified when someone replies to your comment": "جب کوئی آپکے تبادلے کا جواب دیتا ہے تو مطلع ہوں",
    "Gift a membership": "",
    "Gift could not be redeemed": "",
    "Gift details": "",
    "Gift duration": "",
    "Gift link copied to clipboard": "",
    "Gift membership": "",
    "Gift redeemed! You're all set.": "",
    "Gift subscription": "",
    "Gift subscriptions are not available right now.": "",
    "Gift value": "",
    "Give feedback on this post": "اس پوسٹ پر فیڈبیک دیں",
    "Help! I'm not receiving emails": "مدد! میرے پاس ای میلز نہیں آ رہے",
    "Here are a few other sites you may enjoy.": "",
    "Hi {recipientName},": "",
    "Hide details": "",
    "How would you like to share this gift?": "",
    "I'll share it myself": "",
    "If a newsletter is flagged as spam, emails are automatically disabled for that address to make sure you no longer receive any unwanted messages.": "اگر کوئی نیوزلیٹر اسپیم کے طور پر چھانا گیا ہے تو اس پتہ کے لئے ای میلز خود بخود غیر فعال ہو جاتے ہیں تاکہ یہ یقینی ہو کہ آپکو مزید کوئی غیر مطلوبہ پیغام نہیں ملے گا۔",
    "If the spam complaint was accidental, or you would like to begin receiving emails again, you can resubscribe to emails by clicking the button on the previous screen.": "اگر اسپیم کے خیالات کی شکایت صدف ہوئی ہو یا آپ مزید ای میلز حاصل کرنا چاہتے ہیں تو آپ پچھلے اسکرین پر دیے گئے بٹن پر کلک کر کے دوبارہ ای میل کی سبسکرپشن کر سکتے ہیں۔",
    "If you cancel your subscription now, you will continue to have access until {periodEnd}.": "اگر آپ اپنی سبسکرپشن اب منسلک کرتے ہیں، آپکو {periodEnd} تک رسائی ملتی رہے گی۔",
    "If you have a corporate or government email account, reach out to your IT department and ask them to allow emails to be received from {senderEmail}": "اگر آپ کا کارپوریٹ یا حکومتی ای میل اکاؤنٹ ہے، اپنے آئٹی ڈیپارٹمنٹ سے رابطہ کریں اور ان سے کہیں کہ وہ ای میلز کو {senderEmail} سے ملنے دیں۔",
    "If you have an account, a login link has been sent to your inbox. If it doesn't arrive in 3 minutes, be sure to check your spam folder.": "ایک لاگ ان لنک آپکے ان باکس میں بھیج دیا گیا ہے۔ اگر 3 منٹ میں نہیں آئی تو یہ یقینی بنائیں کہ آپکے اسپیم فولڈر کو چیک کریں۔",
    "If you have an account, an email has been sent to {submittedEmailOrInbox}. Click the link inside or enter your code below.": "",
    "If you would like to start receiving emails again, the best next steps are to check your email address on file for any issues and then click resubscribe on the previous screen.": "اگر آپ مزید ای میلز حاصل کرنا چاہتے ہیں، تو بہترین اگلا قدم یہ ہے کہ آپ اپنے فائل میں اپنا ای میل ایڈریس چیک کریں اور پھر پچھلے اسکرین پر دئیے گئے دوبارہ سبسکرائب پر کلک کریں۔",
    "If you're not receiving the email newsletter you've subscribed to, here are a few things to check.": "",
    "If you've completed all these checks and you're still not receiving emails, you can reach out to get support by contacting {supportAddress}.": "اگر آپ نے تمام چیکس مکمل کی ہیں اور آپکو مزید ای میلز نہیں مل رہے ہیں، تو آپ {supportAddress} سے رابطہ کر کے حمایت حاصل کر سکتے ہیں۔",
    "In the event a permanent failure is received when attempting to send a newsletter, emails will be disabled on the account.": "اگر کوشش کرتے وقت نیوزلیٹر بھیجنے پر ہمیشہ کے لئے ناکامی ہوتی ہے تو اکاؤنٹ پر ای میلز غیر فعال ہو جائیں گے۔",
    "In your email client add {senderEmail} to your contacts list. This signals to your mail provider that emails sent from this address should be trusted.": "اپنے ای میل کلائنٹ میں {senderEmail} کو اپنی رابطہ فہرست میں شامل کریں۔ یہ آپکے میل فراہم کنندہ کو اشارہ ہوتا ہے کہ اس پتہ سے بھیجے گئے ای میلز پر اعتماد کیا جانا چاہئے۔",
    "Invalid email address": "",
    "Invalid verification code": "",
    "Jamie Larson": "",
    "jamie@example.com": "",
    "Less like this": "اس طرح کم",
    "LinkedIn": "",
    "Make sure emails aren't accidentally ending up in the Spam or Promotions folders of your inbox. If they are, click on \"Mark as not spam\" and/or \"Move to inbox\".": "یہ یہ سنجیدہ ہو کہ ای میلز اتفاقی طور پر آپکے ان باکس کے اسپیم یا پروموشن فولڈرز میں ختم نہیں ہو رہے ہیں۔ اگر ہیں تو \"غیر فعال ہے\" پر کلک کریں اور/یا \"ان باکس میں منتقل کریں\"۔",
    "Manage": "منظم کریں",
    "Maybe later": "",
    "Membership details": "",
    "Memberships from this email domain are currently restricted.": "",
    "Memberships unavailable, contact the owner for access.": "",
    "month": "",
    "Monthly": "ہر مہینے",
    "More like this": "اس کی مزید",
    "More options": "",
    "Name": "نام",
    "Need more help? Contact support": "مزید مدد چاہیے؟ حمایت سے رابطہ کریں",
    "Newsletters can be disabled on your account for two reasons: A previous email was marked as spam, or attempting to send an email resulted in a permanent failure (bounce).": "نیوزلیٹرز کو آپکے اکاؤنٹ پر غیر فعال کرنے کے دو ممکنہ وجوہات ہیں: پچھلا ای میل اسپیم مارک کیا گیا تھا یا ای میل بھیجنے کی کوشش نے ہمیشہ کے لئے ناکامی (باؤنس) کا نتیجہ دیا۔",
    "No member exists with this e-mail address.": "",
    "No thanks, I want to cancel": "",
    "Not ready to share? We've also emailed a copy to your inbox.": "",
    "Not receiving emails?": "ای میلز نہیں آ رہے؟",
    "Now": "",
    "Now check your email!": "اب اپنے ای میل چیک کریں!",
    "Occasional updates from {siteTitle}": "",
    "Once resubscribed, if you still don't see emails in your inbox, check your spam folder. Some inbox providers keep a record of previous spam complaints and will continue to flag emails. If this happens, mark the latest newsletter as 'Not spam' to move it back to your primary inbox.": "جب ایک بار دوبارہ سبسکرائب ہو جائے، اگر آپکو مزید ای میلز اپنے ان باکس میں نہیں دکھتے ہیں تو اپنے ان باکس کی سپیم فولڈر چیک کریں۔ کچھ ان باکس فراہم کنندگان نے پچھلے اسپیم شکایات کا ریکارڈ رکھا ہوتا ہے اور وہ ای میلز کو جاری رکھتے ہیں۔ اگر یہ ہوتا ہے، تو آخری نیوزلیٹر کو 'غیر فعال' مارک کریں تاکہ یہ اسے دوبارہ آپکے پرائمری ان باکس میں منتقل کریں۔",
    "Open AOL Mail": "",
    "Open email": "",
    "Open Feedbin": "",
    "Open Gmail": "",
    "Open Hey": "",
    "Open iCloud Mail": "",
    "Open Mail.ru": "",
    "Open Outlook": "",
    "Open Proton Mail": "",
    "Open Yahoo Mail": "",
    "Optional message": "",
    "Permanent failure (bounce)": "ہمیشہ کے لئے ناکامی (باؤنس)",
    "Phone number": "",
    "Plan": "پلان",
    "Plan checkout was cancelled.": "پلان چیک آؤٹ منسوخ ہوگیا تھا۔",
    "Plan upgrade was cancelled.": "پلان اپگریڈ منسوخ ہوگیا تھا۔",
    "Please contact {supportAddress} to adjust your complimentary subscription.": "",
    "Please enter {fieldName}": "",
    "Please fill in required fields": "براہ کرم مطلوبہ شعبے بھریں",
    "Podcasts": "",
    "Postal code": "",
    "Re-enable emails": "ای میلز کو دوبارہ چالو کریں",
    "Recipient's email": "",
    "Recipient's name": "",
    "Recommendations": "",
    "Redeem your gift": "",
    "Redeeming...": "",
    "Renews at {price}.": "نیا کرتا ہے {price} پر۔",
    "Resume subscription": "",
    "Retry": "مزید کوشش",
    "Save": "محفوظ کریں",
    "Save {amountOff} on your next {durationInMonths} billing cycles. Then {currency}{originalPrice}/{cadence}.": "",
    "Save {amountOff} on your next billing cycle. Then {currency}{originalPrice}/{cadence}.": "",
    "Send the link below to share it with whoever you'd like.": "",
    "Sending login link...": "لاگ ان لنک بھیجا جا رہا ہے...",
    "Sending...": "بھیجا جا رہا ہے...",
    "Share": "",
    "Share a full membership to {siteTitle} with a friend or colleague": "",
    "Share it yourself": "",
    "Show all": "",
    "Sign in": "سائن ان",
    "Sign out": "لاگ آؤٹ",
    "Sign up": "سائن اپ",
    "Signup error: Invalid link": "سائن اپ خطا: غیر معتبر لنک",
    "Signups from this email domain are currently restricted.": "",
    "Something went wrong, please try again later.": "",
    "Sorry, no paid plans are available.": "",
    "Sorry, no recommendations are available right now.": "",
    "Sorry, that didn’t work.": "معاف کریں، یہ کام نہیں کیا گیا۔",
    "Spam complaints": "سپیم شکایتیں",
    "Start {amount}-day free trial": "{amount} دن کا مفت ٹرائل شروع کریں",
    "Starting {startDate}": "{startDate} سے شروع ہو رہا ہے",
    "Starting today": "آج سے شروع ہو رہا ہے",
    "State": "",
    "Submit feedback": "رائے دیں",
    "Subscribe": "سبسکرائب کریں",
    "Subscribed": "سبسکرائب ہوگیا",
    "Subscription plan updated successfully": "",
    "Success": "کامیابی",
    "Success! Check your email for magic link to sign-in.": "کامیابی! سائن ان کے لئے جادوی لنک کے لئے اپنا ای میل چیک کریں۔",
    "Success! Your account is fully activated, you now have access to all content.": "کامیابی! آپ کا اکاؤنٹ مکمل طور پر چالو ہوا ہے، آپ کو اب تمام مواد تک رسائی ہے۔",
    "Success! Your email is updated.": "کامیابی! آپ کا ای میل اپ ڈیٹ ہوا ہے۔",
    "Successfully unsubscribed": "کامیابی سے ہوشیاری ہٹا دی گئی ہے",
    "Taylor Reid": "",
    "taylor@example.com": "",
    "Thank you for subscribing. Before you start reading, below are a few other sites you may enjoy.": "",
    "Thank you for your support": "",
    "Thank you for your support!": "",
    "Thanks for the feedback!": "رائے کے لئے شکریہ!",
    "That didn't go to plan": "وہ خواہش تھی، لیکن ہو نہ سکی",
    "The email address we have for you is {memberEmail} — if that's not correct, you can update it in your <button>account settings area</button>.": "ہمارے پاس آپ کا ای میل ایڈریس ہے {memberEmail} — اگر یہ درست نہیں ہے، تو آپ اسے اپنے <button>اکاؤنٹ کی سیٹنگز ایریا</button> میں اپ ڈیٹ کر سکتے ہیں۔",
    "There was a problem submitting your feedback. Please try again a little later.": "آپ کی رائے جمع کرنے میں مشکل ہوئی۔ براہ کرم ٹھوڑی دیر بعد دوبارہ کوشش کریں۔",
    "There was an error cancelling your subscription, please try again.": "",
    "There was an error continuing your subscription, please try again.": "",
    "There was an error processing your payment. Please try again.": "",
    "There was an error sending the email, please try again": "",
    "This gift can only be redeemed once and expires on {expiryDate}.": "",
    "This gift has already been consumed.": "",
    "This gift has already been redeemed.": "",
    "This gift has been refunded.": "",
    "This gift has expired.": "",
    "This gift link is invalid.": "",
    "This site is invite-only, contact the owner for access.": "یہ سائٹ صرف دعوتی ہے، دستیابی کے لئے مالک سے رابطہ کریں۔",
    "This site is not accepting donations at the moment.": "",
    "This site is not accepting payments at the moment.": "",
    "This site only accepts paid members.": "",
    "This unsubscribe link belongs to a different email address than the one you are signed in with.": "",
    "Threads": "",
    "Tier": "",
    "To": "",
    "To complete signup, click the confirmation link in your inbox. If it doesn't arrive within 3 minutes, check your spam folder!": "سائن اپ مکمل کرنے کے لئے، اپنے ان باکس میں تصدیق کے لنک پر کلک کریں۔ اگر 3 منٹ کے اندر نہ آئے تو، اپنا اسپیم فولڈر چیک کریں!",
    "To continue to stay up to date, subscribe to {publication} below.": "",
    "Too many attempts try again in {number} days.": "",
    "Too many attempts try again in {number} hours.": "",
    "Too many attempts try again in {number} minutes.": "",
    "Too many different sign-in attempts, try again in {number} days": "",
    "Too many different sign-in attempts, try again in {number} hours": "",
    "Too many different sign-in attempts, try again in {number} minutes": "",
    "Too many sign-up attempts, try again later": "",
    "Try free for {amount} days, then {originalPrice}.": "مفت ٹرائل کے لئے کوشش کریں {amount} دن، پھر {originalPrice}۔",
    "Unable to initiate checkout session": "",
    "Unlock access to all newsletters by becoming a paid subscriber.": "ایک ادائیگی چکچکی بن کر تمام نیوزلیٹرز کا رسائی کھولیں۔",
    "Unsubscribe from all emails": "تمام ای میلز سے ہوشیار ہو جائیں",
    "Unsubscribed": "ہوشیار ہوگیا ہے",
    "Unsubscribed from all emails.": "",
    "Unsubscribing from emails will not cancel your paid subscription to {title}": "ای میلز سے ہوشیار ہونا آپ کا پردہ فوریہ ہوشیاری {title} کی طرف سے منسوخ نہیں کرے گا",
    "Update": "اپ ڈیٹ",
    "Update your preferences": "اپنی ترجیحات کو اپ ڈیٹ کریں",
    "Updates & announcements": "",
    "Verification link sent, check your inbox": "",
    "Verify your email address is correct": "اپنا ای میل ایڈریس درست ہے یہ تصدیق کریں",
    "Verifying...": "",
    "View plans": "پلان دیکھیں",
    "We couldn't unsubscribe you as the email address was not found. Please contact the site owner.": "ہم آپ کو ہوشیار نہیں کر سکے کیونکہ ای میل ایڈریس نہیں ملا۔ براہ کرم سائٹ کے مالک سے رابطہ کریں۔",
    "We'd hate to see you leave. How about a special offer to stay?": "",
    "We'll email it to the recipient on {deliveryDate}. A copy is in your inbox too.": "",
    "We'll email it to the recipient. A copy will be in your inbox too.": "",
    "Welcome back, {name}!": "خوش آمدید واپس، {name}!",
    "Welcome back!": "خوش آمدید واپس!",
    "Welcome to {siteTitle}": "",
    "What's included": "",
    "When an inbox fails to accept an email it is commonly called a bounce. In many cases, this can be temporary. However, in some cases, a bounced email can be returned as a permanent failure when an email address is invalid or non-existent.": "جب ایک ان باکس ایک ای میل قبول کرنے میں ناکام ہوتا ہے تو عام طور پر اسے باؤنس کہا جاتا ہے۔ بہت سے مواقعوں میں، یہ عارضی ہوتا ہے۔ تاہم، کچھ مواقعوں میں، ایک باؤنس ای میل غیر معتبر یا موجود نہ ہونے کی صورت میں ہمیشہ کے لئے واپس بھیجا جا سکتا ہے۔",
    "Why has my email been disabled?": "میرا ای میل کیوں غیر فعال ہوگیا ہے؟",
    "X (Twitter)": "",
    "year": "",
    "Yearly": "سالانہ",
    "You already have an active subscription.": "",
    "You currently have a free membership, upgrade to a paid subscription for full access.": "آپ کا موجودہ مفت ممبرشپ ہے، پورے رسائی حاصل کرنے کے لئے ایک ادائیگی چکچکی پر اپگریڈ کریں۔",
    "You have been successfully resubscribed": "آپ نے کامیابی سے دوبارہ ہوشیاری حاصل کی ہے",
    "You now have access to {tierName} until {expiryDate}. Enjoy!": "",
    "You're currently not receiving emails": "آپ حال ہی میلز نہیں پارہ ہیں",
    "You're not receiving emails": "آپ کو ای میل نہیں آ رہا ہے",
    "You're not receiving emails because you either marked a recent message as spam, or because messages could not be delivered to your provided email address.": "آپ کو ای میل نہیں مل رہا ہے کیونکہ آپ نے حال ہی میسج کو سپیم مارک کیا ہوا ہے یا یہاں فراہم کردہ ای میل ایڈریس پر پیغامات فراہم نہیں کیے جا سکتے ہیں۔",
    "You've been gifted a <strong>{duration}-month</strong> {tierName} membership_one": "",
    "You've been gifted a <strong>{duration}-month</strong> {tierName} membership_other": "",
    "You've been gifted a <strong>{duration}-month</strong> {tierName} membership to {siteTitle}_one": "",
    "You've been gifted a <strong>{duration}-month</strong> {tierName} membership to {siteTitle}_other": "",
    "You've been gifted a <strong>{duration}-year</strong> {tierName} membership": "",
    "You've been gifted a <strong>{duration}-year</strong> {tierName} membership to {siteTitle}": "",
    "You've successfully signed in.": "آپ نے کامیابی سے سائن ان کیا ہے۔",
    "You've successfully subscribed to <strong>{siteTitle}</strong>": "",
    "Your account": "آپ کا اکاؤنٹ",
    "Your email": "",
    "Your email has failed to resubscribe, please try again": "",
    "Your gift is on its way": "",
    "Your gift is ready": "",
    "Your gift is scheduled": "",
    "Your gift subscription will expire on {expiryDate}": "",
    "your inbox": "",
    "Your input helps shape what gets published.": "آپ کا مدخلہ وہ چیزیں شکل دینے میں مدد فراہم کرتا ہے جو شائع ہوتی ہیں۔",
    "Your name": "",
    "Your subscription has been canceled and will expire on {expiryDate}.": "",
    "Your subscription will expire on {expiryDate}": "آپ کی ہوشیاری {expiryDate} تک چلے گی",
    "Your subscription will renew on {renewalDate}": "آپ کی ہوشیاری {renewalDate} تک تجدید ہوگی",
    "Your subscription will start on {subscriptionStart}": "آپ کی ہوشیاری {subscriptionStart} پر شروع ہوگی"
}
